module.exports = __webpack_public_path__ + "img/draw-basewsoccerball.90551e18.webp";